import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { prefixErrorText } from 'utils/react-hook-form'

interface ChoiceItem {
  label:string;
  value:string
  disabled?:boolean;
  customToolTip?: React.ReactNode;
}

interface MyChoiceListProps {
  variableInputName: string;
  choices: Array<ChoiceItem>;
  label: string;
  errorMessageString: string;
  inputClassName?: string;
  addErrorPrefix?: boolean;
  headingLevel?: '1' | '2' | '3' | '4' | '5' | '6'
}

export const MyChoiceList: React.FC<MyChoiceListProps> = ({
  addErrorPrefix, // TODO - set this to true for MCF prod ticket update on "Error:" and remove all of the props specified in AuthRepForm
  inputClassName,
  variableInputName,
  choices,
  label,
  errorMessageString,
  headingLevel
}) => {
  const { formState, control } = useFormContext()
  const { errors } = formState
  const Heading = `h${headingLevel ?? 3}` as unknown as React.FC<{ className: string, children: React.ReactNode }>
  return (
    <fieldset className='ds-c-fieldset' aria-invalid={!!errors[variableInputName]} id={variableInputName} data-testid={variableInputName}>
      {label && <legend className='ds-c-label'><Heading className='ds-text-heading--xl'>{label}</Heading></legend>}
      <Controller
        rules={{ required: { value: true, message: errorMessageString } }}
        key={`${variableInputName}`}
        render={({ field, fieldState }) => {
          return (
            <div
              key={field.name}
              aria-labelledby={field.name && `radiogroup-${field.name}`}
             >
              {choices.map((item, index) => (
                <div className='ds-u-margin-y--2'>
                  <div key={index} className='ds-c-choice-wrapper'>
                    <input
                      ref={field.ref}
                      disabled={item.disabled}
                      aria-describedby={fieldState.error ? `error-${field.name}` : undefined}
                      id={`${field.name}-${item.value}`}
                      name={field.name}
                      onChange={field.onChange as any}
                      onBlur={field.onBlur as any}
                      className={`${inputClassName || ''} ds-c-choice ${fieldState?.error?.message ? 'ds-c-choice--error' : ''}`}
                      type='radio'
                      value={item.value}
                      data-testid={`${field.name}-${item.value}`}
                      checked={field.value === item.value}
                    />
                    <label className='ds-c-label' htmlFor={`${field.name}-${item.value}`}>
                      <span>{item.label}</span>
                    </label>
                  </div>
                  {item.customToolTip || null}
                </div>
              ))}
            </div>
          )
        }}
        name={`${variableInputName}`}
        control={control}
      />

      {errors[variableInputName] &&
        <span id={`error-${variableInputName}`} className='ds-c-field__error-message my-u-mt--3'>
            {addErrorPrefix ? prefixErrorText(errors[variableInputName]?.message) : errors[variableInputName]?.message}
        </span>}
    </fieldset>
  )
}
